import { SegmentsRow as SharedSegmentsRow } from '@/features/dryad';
import { peopleFilterBuilder } from './builder';
import { ConditionType } from './condition-types';
import { ConditionTypeSelect } from './condition-type-select';
import { toSegmentId } from './segments-plugin';

type SegmentsRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared segment-membership row. */
export function SegmentsRow({ id }: SegmentsRowProps) {
  const meta = peopleFilterBuilder.useMeta();

  return (
    <SharedSegmentsRow
      id={id}
      conditionType={ConditionType.SegmentsNegatable}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.SegmentsNegatable} />}
      toSegmentId={toSegmentId}
      onCreateSegment={meta.onCreateSegment}
    />
  );
}
